import { FC } from 'react'
import { styled, Typography } from '@mui/material'

export type CitationProps = {
  children?: string | JSX.Element | JSX.Element[]
  className?: string
  style?: React.CSSProperties
}

export const Citation: FC<CitationProps> = ({ children, className, style }) => {
  return (
    <StyledTypography
      className={className}
      style={style}
      variant='body2'
      variantMapping={{
        body2: 'cite',
      }}
    >
      {children}
    </StyledTypography>
  )
}

const StyledTypography = styled(Typography)(({ theme: { spacing, typography } }) => ({
  display: 'block',
  fontStyle: 'italic',
  marginBottom: spacing(3),
}))
